import moment from 'moment/moment';
import Moment from 'react-moment';
import {connect} from "react-redux";
import React, {Component, Fragment} from 'react';
import ViewHeader from '../view-header';
import ReactTooltip from 'react-tooltip';
import 'react-datepicker/dist/react-datepicker.css';
import ModalComponent from '../../../../components/Modal';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Notice from "../../../../components/Notification/newNotification";
import CustomModalBody from '../../../../components/AvailableUnits/addNewUnits'
import CustomModalBodyEdit from '../../../../components/AvailableUnits/editUnits'
import {addAvailableUnits, getAvailableUnits, getAvailableUnitsList, deleteUnite, editUnite} from './actions';
import Pagination from "rc-pagination";

//Icons
import IconSpinner from 'react-icons/lib/fa/spinner';
import {getDefaultFilters} from "../Patients/helpers";
import _ from "lodash";
import {scrollTo} from "../../../../helpers";
import {globals} from "../../../../../../common/constants";
import {getCustomFilter} from "../../../../components/CustomInput";

class AvailableUnits extends Component {
    constructor(props) {
        super(props);
        let locationState = this.props.history.location.state;
        const locationStateDefaults = getDefaultFilters();
        locationState = _.assign(locationStateDefaults, locationState);
        this.state = {
            openNewForm: false,
            openEditForm: false,
            startDate: moment().add(10, 'days'),
            numberOfUnits: 0,
            inputNumberOfUnits: 0,
            units_for_zirconia: 0,
            changed: true,
            uniteId: 0,
            removeUnitsModal: false,
            editedData: {
                id: 0,
                startDate: '',
                inputNumberOfUnits: 0,
                editNumberOfUnits: 0,
                units_for_zirconia: 0,
                alreadyBookedZirconia: 0
            },
            validationNumber: {
                status: false,
                message: ''
            },
            validationDate: {
                status: false,
                message: ''
            },
            validationNumberZyrconia: {
                status: false,
                message: ''
            },
            filterData: {
                filterOptions: locationState.filterData.filterOptions,
                sortingOptions: locationState.filterData.sortingOptions
            },
            option: {
                noDataText: 'No custom unit count is available yet.',
                hideSizePerPage: true,
                sizePerPage: 15,
                page: locationState.pageNumber,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
                onPageChange: (page) => this.handlePageChange(page),
                expandBodyClass: "tr-opened",
                onExpand: (rowId, isExpand) => {
                    if (isExpand) {
                        return this.setState({ selectedRowId: rowId });
                    }
                    this.setState({ selectedRowId: null });
                }
            },
            selectedRowId: null,
            focusedField: null
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDateChangeEdit = this.handleDateChangeEdit.bind(this);
        this.actionFormatter = this.actionFormatter.bind(this);
    }

    componentDidMount () {
        document.title = "Available units";
        this.props.getAvailableUnitsList({
            startDate: this.state.startDate,
            filterOptions: this.state.filterData.filterOptions
        });
        this.interval = setInterval(() => this.props.getAvailableUnitsList({
            startDate: this.state.startDate,
            filterOptions: this.state.filterData.filterOptions
        }), 7000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handlePageChange = (page) => {
        scrollTo(0, 'smooth');
        this.setState({
            option: {
                ...this.state.option,
                page
            }
        })
    }

    changeSortingOptions = (field, order) => {
        this.setState({
            filterData: {
                sortingOptions: {
                    [field]: order
                },
                filterOptions: {
                    ...this.state.filterData.filterOptions
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const {filterOptions, sortingOptions} = this.state.filterData;
            this.props.getAvailableUnitsList({page, sortingOptions, filterOptions});
        });
    }

    handleClose() {
        this.setState({
            removeUnitsModal: false,
            inputNumberOfUnits: 0,
            units_for_zirconia: 0,
            openNewForm: false,
            openEditForm: false,
            editedData: {
                id: 0,
                startDate: '',
                inputNumberOfUnits: 0,
                editNumberOfUnits: 0,
                units_for_zirconia: 0,
                alreadyBookedZirconia: 0,
            },
            validationNumber: {
                status: false,
                message: '',
            },
            validationDate: {
                status: false,
                message: ''
            },
            validationNumberZyrconia: {
                status: false,
                message: '',
            }
        });
        const {filterOptions} = this.state.filterData;
        this.props.getAvailableUnitsList({startDate: this.state.startDate, filterOptions});
        this.interval = setInterval(() => this.props.getAvailableUnitsList({
            startDate: this.state.startDate,
            filterOptions
        }), 7000)
    }

    dateFormatter(cell) {
        return (
            <Moment format="DD/MM/YYYY">
                {cell}
            </Moment>
        );
    }

    toggle() {
        this.props.getAvailableUnits({date: moment().add(10, 'days')})
        this.setState({startDate: moment().add(10, 'days'), openNewForm: !this.state.openNewForm,});
        clearInterval(this.interval);
    }

    handelChange(key, value) {
        if (this.state.inputNumberOfUnits > 0 || this.state.inputNumberOfUnits !== '') {
            this.setState({
                validationNumber: {
                    status: false,
                }
            });
        } else if (this.state.inputNumberOfUnits >= this.state.numberOfUnits.misc) {
            this.setState({
                validationNumber: {
                    status: false,
                }
            });
        } else if (this.state.startDate) {
            this.setState({
                validationDate: {
                    status: false,
                }
            });
        }
        if (this.state.units_for_zirconia > 0 || this.state.units_for_zirconia !== '') {
            this.setState({
                validationNumberZyrconia: {
                    status: false,
                }
            });
        } else if (this.state.units_for_zirconia >= this.state.numberOfUnits.zirconia) {
            this.setState({
                validationNumberZyrconia: {
                    status: false,
                }
            });
        }
        this.setState({[key]: value});
    }

    handelChangeEdit(key, value) {
        if (this.state.editedData.inputNumberOfUnits > 0 || this.state.editedData.inputNumberOfUnits !== '') {
            this.setState({
                validationNumber: {
                    status: false,
                }
            });
        } else if (this.state.editedData.inputNumberOfUnits >= this.state.editedData.editNumberOfUnits) {
            this.setState({
                validationNumber: {
                    status: false,
                }
            });
        }
        if (this.state.editedData.units_for_zirconia > 0 || this.state.editedData.units_for_zirconia !== '') {
            this.setState({
                validationNumberZyrconia: {
                    status: false,
                }
            });
        } else if (this.state.editedData.units_for_zirconia >= this.state.editedData.alreadyBookedZirconia) {
            this.setState({
                validationNumberZyrconia: {
                    status: false,
                }
            });
        }
        this.setState({
            editedData: {
                ...this.state.editedData,
                [key]: value
            }
        });
    }

    handleDateChange(date) {
        this.props.getAvailableUnits({date})
        this.setState({startDate: date})
    }

    handleDateChangeEdit(date) {
        this.setState({
            editedData: {
                ...this.state.editedData,
                startDate: date
            }
        }, () => {
            this.props.getAvailableUnits({date})
        })
    }

    handleSaveNewUnits() {
        if (this.state.inputNumberOfUnits < 0 || this.state.inputNumberOfUnits === '') {
            this.setState({
                validationNumber: {
                    status: true,
                    message: "Not valid Number"
                }
            });
        } else if (this.state.inputNumberOfUnits < this.state.numberOfUnits.misc) {
            this.setState({
                validationNumber: {
                    status: true,
                    message: `${this.state.numberOfUnits.misc} number of units are booked. The number of units per day can't be less than units already booked`
                }
            });
        } else if (!this.state.startDate) {
            this.setState({
                validationDate: {
                    status: true,
                    message: "The date field is required."
                }
            });
        } else if (this.state.units_for_zirconia < 0 || this.state.units_for_zirconia === '') {
            this.setState({
                validationNumberZyrconia: {
                    status: true,
                    message: "Not valid Number"
                }
            });
        } else if (this.state.units_for_zirconia < this.state.numberOfUnits.zirconia) {
            this.setState({
                validationNumberZyrconia: {
                    status: true,
                    message: `${this.state.numberOfUnits.zirconia} number of units are booked. The number of units per day can't be less than units already booked`
                }
            });
        } else if (!this.state.startDate) {
            this.setState({
                validationDate: {
                    status: true,
                    message: "The date field is required."
                }
            });
        } else {
            this.setState({
                validationNumber: {
                    status: false,
                    message: ""
                },
                validationNumberZyrconia: {
                    status: false,
                    message: ""
                }
            });
            this.props.addAvailableUnits({
                startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                numberOfUnits: this.state.inputNumberOfUnits,
                units_for_zirconia:
                this.state.units_for_zirconia,
            });
            const {filterOptions} = this.state.filterData;
            this.props.getAvailableUnitsList({
                startDate: this.state.startDate,
                filterOptions
            });
            this.interval = setInterval(() => this.props.getAvailableUnitsList({
                startDate: this.state.startDate,
                filterOptions
            }), 7000)
        }
    }

    dentistArrow = () => {
        return <div>
            <span className="kr kr-arrow"/>
        </div>
    }

    actionFormatter(row, cell) {
        return (
            <div>
                <button data-tip="Edit" className={"btn edit-action"} onClick={(event) => this.onEditUnits(cell)}>
                    <span className="kr kr-edit"/>
                </button>
                <button data-tip="Delete" className={"btn delete-action"}
                        onClick={(event) => this.onRemoveUnits(cell.id)}>
                    <span className="kr kr-delete"/>
                </button>
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
        );
    }

    casesFormatter(row, cell) {
        let listOfCases = "";
        if (cell.cases !== undefined) {
            listOfCases = cell.cases.map((item, index) => (
                <li key={index}>{item}</li>
            ))
        }
        return (<ul>{listOfCases}</ul>)
    }

    onRemoveUnits(id) {
        if (!this.state.removeUnitsModal) {
            this.setState({removeUnitsModal: true, uniteId: id});
        } else {
            this.props.deleteUnite({id, startDate: this.state.startDate})
        }
    }

    onEditUnits(data) {
        clearInterval(this.interval);
        if (!this.state.openEditForm) {
            this.setState({
                editedData: {
                    id: data.id,
                    startDate: moment(data.dateOfReturn),
                    inputNumberOfUnits: data.numberOfUnits,
                    editNumberOfUnits: data.alreadyBooked,
                    units_for_zirconia: data.units_for_zirconia,
                    alreadyBookedZirconia: data.alreadyBookedZirconia
                },
                openEditForm: true
            });
        } else {
            if (this.state.editedData.inputNumberOfUnits < 0 || this.state.editedData.inputNumberOfUnits === '') {
                this.setState({
                    validationNumber: {
                        status: true,
                        message: "Not valid Number"
                    }
                });
            } else if (this.state.editedData.inputNumberOfUnits < this.state.editedData.editNumberOfUnits) {
                this.setState({
                    validationNumber: {
                        status: true,
                        message: "Number of units can't be less then already booked"
                    }
                });
            } else if (this.state.editedData.units_for_zirconia < 0 || this.state.editedData.units_for_zirconia === '') {
                this.setState({
                    validationNumberZyrconia: {
                        status: true,
                        message: "Not valid Number"
                    }
                });
            } else if (this.state.editedData.units_for_zirconia < this.state.editedData.alreadyBookedZirconia) {
                this.setState({
                    validationNumberZyrconia: {
                        status: true,
                        message: "Number of units can't be less then already booked"
                    }
                });
            } else {
                const sending = {
                    ...this.state.editedData,
                    startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                    date: moment(this.state.startDate).format('YYYY-MM-DD')
                }
                this.props.editUnite(sending)
            }

        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        const adminAvailableUnits = nextProps.adminAvailableUnits;
        if (adminAvailableUnits.validationStatus) {
            Notice.addNotification(adminAvailableUnits.validationMessage, 'error');
            this.setState({openNewForm: false, openEditForm: false})
        } else if (adminAvailableUnits.added) {
            Notice.addNotification('Custom counts for units successfully added.', 'success');
            this.setState({openNewForm: false})
        } else if (adminAvailableUnits.edited) {
            Notice.addNotification('Custom counts for units successfully edited.', 'success');
            this.setState({openEditForm: false})
        } else if (adminAvailableUnits.deleted) {
            Notice.addNotification('Custom counts for units successfully deleted.', 'success');
            this.setState({removeUnitsModal: false, openEditForm: false})
        } else if (adminAvailableUnits.deleted === false) {
            this.setState({removeUnitsModal: false, openEditForm: false})
        }
        this.setState({
            numberOfUnits: adminAvailableUnits.numberOfUnits,
            inputNumberOfUnits: 0,
            units_for_zirconia: 0,
            changed: adminAvailableUnits.changeDate,
            editedData: {
                ...this.state.editedData,
                editNumberOfUnits: adminAvailableUnits.getOne ? adminAvailableUnits.numberOfUnits : this.state.editedData.editNumberOfUnits
            },
            validationNumber: {
                status: false,
                message: ''
            },
            validationDate: {
                status: false,
                message: ''
            },
            validationNumberZyrconia: {
                status: false,
                message: ''
            }
        })
    }

    trClassFormat = (rowData) => {
        return `dentist-table-cursor mb-table ${this.state.selectedRowId === rowData.id ? 'active-row' : ''}`;
    }

    setFocused = (fieldName) => {
        this.setState({focusedField: fieldName});
    }

    changeFilterOptions = (key, value) => {
        const filterOptions = {
            ...this.state.filterData.filterOptions,
            [key]: value
        }
        if (value.length === 0) {
            delete filterOptions[key];
        }
        this.setState({
                filterData: {...this.state.filterData, filterOptions}
            },
            () => {
                this.props.getAvailableUnitsList({
                    filterOptions,
                    startDate: this.state.startDate,
                })
            });

    }

    render() {
        const header = 'Available Units';
        const desc = 'List of all custom count for units';
        const navBig = document.body.clientWidth > globals.NAV_MIDDLE;

        const mobileTableRender = () => {
            return (
                <BootstrapTable
                    expandableRow={() => true}
                    expandComponent={expandComponent}
                    className="dentist-mobile-table"
                    data={this.props.adminAvailableUnits.data}
                    options={this.state.option}
                    trClassName={this.trClassFormat}
                    responsive
                    pagination
                    striped
                    ignoreSinglePage
                >
                    <TableHeaderColumn
                        isKey
                        width="50"
                        dataField='id'
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            placeholder: '',
                            defaultValue: {comparator: '='},
                            customFilterParameters: {
                                type: 'number',
                                input_name: 'id',
                                focused: this.state.focusedField === 'id',
                                focus: this.setFocused,
                                activeClassName: 'active-field',
                                blur: () => this.setFocused(null),
                                placeholder: '',
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                        dataSort={true}
                    >
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="60"
                        dataField='numberOfUnits'
                        dataSort={true}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            placeholder: '',
                            defaultValue: {comparator: '='},
                            customFilterParameters: {
                                type: 'number',
                                input_name: 'units',
                                focused: this.state.focusedField === 'units',
                                focus: this.setFocused,
                                activeClassName: 'active-field',
                                blur: () => this.setFocused(null),
                                placeholder: '',
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        Misc
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="60"
                        dataField='units_for_zirconia'
                        dataSort={true}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            placeholder: '',
                            defaultValue: {comparator: '='},
                            customFilterParameters: {
                                type: 'number',
                                input_name: 'units_for_zirconia',
                                focused: this.state.focusedField === 'units_for_zirconia',
                                focus: this.setFocused,
                                activeClassName: 'active-field',
                                blur: () => this.setFocused(null),
                                placeholder: '',
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        Zrc/Cer
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="100"
                        dataField='cases'
                        dataFormat={this.casesFormatter}
                    >
                        Cases
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="30"
                        dataFormat={this.dentistArrow}
                    />
                </BootstrapTable>
            )
        }

        const expandComponent = (row) => {
            return <div className="tb-block table_drop_row">
                <div className="tb-block__item">
                    <span>Date</span>
                    <span>{row.dateOfReturn}</span>
                </div>
                <div className="tb-block__item">
                    <span>Booked Misc</span>
                    <span>{row.alreadyBooked}</span>
                </div>
                <div className="tb-block__item">
                    <span>Booked Zrc/Cer</span>
                    <span>{row.alreadyBookedZirconia}</span>
                </div>
                <div className="tb-block__action">
                    {this.actionFormatter(row, row)}
                </div>
            </div>
        }

        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    openModal={() => this.toggle()}
                    openConvertModal={() => this.toggle()}
                    secondaryButtonName={'New Custom Units Count'}
                    showPrimary={false}
                    showSecondary={true}
                />
                <div className="view-content">
                    <div className="table-block">
                        <div>
                            {


                                (this.props.adminAvailableUnits.loading) ?
                                    <h1 className="text-center"><IconSpinner className="spinner"/> Loading...</h1> :
                                    <Fragment>
                                        {navBig ? <BootstrapTable data={this.props.adminAvailableUnits.data}
                                                                  options={this.state.option}
                                                                  responsive
                                                                  pagination
                                                                  striped
                                                                  ignoreSinglePage>
                                            <TableHeaderColumn
                                                isKey
                                                width="120"
                                                dataField='id'
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    defaultValue: {comparator: '='},
                                                    customFilterParameters: {
                                                        type: 'number',
                                                        input_name: 'id',
                                                        placeholder: 'Search',
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}
                                                dataSort={true}
                                            >
                                                ID
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="170"
                                                dataField='dateOfReturn'
                                                dataFormat={this.dateFormatter}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    placeholder: 'Search',
                                                    customFilterParameters: {
                                                        defaultValue: '',
                                                        input_name: 'date',
                                                        changeFilterOptions: this.changeFilterOptions,
                                                        type: 'date',
                                                    }
                                                }}
                                                dataSort={true}
                                            >
                                                Date Of Return
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="148"
                                                dataField='numberOfUnits'
                                                dataSort={true}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    defaultValue: {comparator: '='},
                                                    customFilterParameters: {
                                                        type: 'number',
                                                        input_name: 'units',
                                                        placeholder: 'Search',
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}
                                            >
                                                Units Misc
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="160"
                                                dataField='units_for_zirconia'
                                                dataSort={true}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    defaultValue: {comparator: '='},
                                                    customFilterParameters: {
                                                        type: 'number',
                                                        input_name: 'units_for_zirconia',
                                                        placeholder: 'Search',
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}
                                            >
                                                Units Zirc/Cer
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="148"
                                                dataField='alreadyBooked'
                                                dataSort={true}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    defaultValue: {comparator: '='},
                                                    customFilterParameters: {
                                                        type: 'number',
                                                        input_name: 'alreadyBooked',
                                                        placeholder: 'Search',
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}
                                            >
                                                Booked Misc
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="180"
                                                dataField='alreadyBookedZirconia'
                                                dataSort={true}
                                               filter={{
                                                   type: 'CustomFilter',
                                                   getElement: getCustomFilter,
                                                   defaultValue: {comparator: '='},
                                                   customFilterParameters: {
                                                       type: 'number',
                                                       input_name: 'alreadyBookedZirconia',
                                                       placeholder: 'Search',
                                                       changeFilterOptions: this.changeFilterOptions
                                                   }
                                               }}
                                            >
                                                Booked Zirc/Cer</TableHeaderColumn>
                                            <TableHeaderColumn width="190" dataField='cases'
                                                               dataFormat={this.casesFormatter}>Cases</TableHeaderColumn>
                                            <TableHeaderColumn width="100"
                                                               dataFormat={this.actionFormatter}>Actions</TableHeaderColumn>
                                        </BootstrapTable> : mobileTableRender()}
                                    </Fragment>
                            }
                            <Pagination
                                locale={{prev_page: 'prev', next_page: 'next'}}
                                className="pagination__rc"
                                showLessItems
                                hideOnSinglePage
                                onChange={this.state.option.onPageChange}
                                current={this.state.option.page}
                                total={this.props.adminAvailableUnits.data.length}
                                pageSize={this.state.option.sizePerPage}
                            />
                        </div>
                        {
                            this.state.removeUnitsModal &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Delete Custom Units Count"
                                modalBody="Are you sure you want to delete the custom units count for this date?"
                                show={this.state.removeUnitsModal}
                                handleClose={() => this.handleClose()}
                                buttonText="Delete"
                                buttonFunction={() => this.onRemoveUnits(this.state.uniteId)}
                            />
                        }
                        {
                            this.state.openNewForm &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Add New Custom Units Count"
                                modalBody={
                                    <CustomModalBody
                                        handelChange={(key, value) => this.handelChange(key, value)}
                                        handleDateChange={this.handleDateChange}
                                        validationNumber={this.state.validationNumber}
                                        validationDate={this.state.validationDate}
                                        validationNumberZyrconia={this.state.validationNumberZyrconia}
                                        startDate={this.state.startDate}
                                        numberOfUnits={this.state.numberOfUnits}
                                        changed={this.state.changed}
                                        inputNumberOfUnits={this.state.inputNumberOfUnits}
                                        units_for_zirconia={this.state.units_for_zirconia}
                                    />
                                }
                                show={this.state.openNewForm}
                                handleClose={() => this.handleClose()}
                                buttonText="Add"
                                buttonFunction={() => this.handleSaveNewUnits()}
                            />
                        }
                        {
                            this.state.openEditForm &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Edit Custom Units Count"
                                modalBody={
                                    <CustomModalBodyEdit
                                        handelChangeEdit={(key, value) => this.handelChangeEdit(key, value)}
                                        handleDateChange={this.handleDateChangeEdit}
                                        validationNumber={this.state.validationNumber}
                                        validationNumberZyrconia={this.state.validationNumberZyrconia}
                                        data={this.state.editedData}
                                        changed={this.state.changed}
                                    />
                                }
                                show={this.state.openEditForm}
                                handleClose={() => this.handleClose()}
                                buttonText="Save"
                                buttonFunction={() => this.onEditUnits(this.state.editedData.id)}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    adminAvailableUnits: state.adminAvailableUnits
});

const mapDispatchToProps = dispatch => {
    return {
        addAvailableUnits: (data) => {
            dispatch(addAvailableUnits(data));
        },
        getAvailableUnits: (date) => {
            dispatch(getAvailableUnits(date));
        },
        getAvailableUnitsList: (date) => {
            dispatch(getAvailableUnitsList(date));
        },
        deleteUnite: (data) => {
            dispatch(deleteUnite(data));
        },
        editUnite: (data) => {
            dispatch(editUnite(data));
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableUnits);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AvailableUnits/index.js